import React from "react";
import { Link } from "react-router-dom";
import "./About.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";
import { MdPeopleAlt } from "react-icons/md";
import { RiMapPin2Fill } from "react-icons/ri";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLeaf,
  faMicrochip,
  faUsers,
  faGlobeAsia,
} from "@fortawesome/free-solid-svg-icons";

function About() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="about-page">
      {/* Section 1: Hero */}
      <section
        id="company-profile"
        className="company-profile text-center"
        data-aos="fade-up"
      >
        <h2 className="profile-title-id">PROFIL PERUSAHAAN</h2>
        <p className="profile-subtitle">
          Pelajari Lebih Lanjut tentang Komitmen dan Keahlian Kami
        </p>
      </section>

      {/* Section 2: Establishment */}
      <section
        className="established-section position-relative"
        data-aos="fade-up"
      >
        {/* Background image */}
        <img
          src="/images/BG - About Us.png"
          alt="Establishment"
          className="establishment-bg"
        />

        <div className="container d-flex flex-column flex-md-row align-items-start position-relative">
          {/* Year Info */}
          <div className="year-banner text-center text-md-start flex-shrink-0 me-md-4 mb-4 mb-md-0">
            <h5 className="fw-bold official-text">
              Resmi didirikan pada tahun
            </h5>
            <h1 className="display-1 fw-bold">2021</h1>
          </div>

          {/* Text Box */}
          <div className="established-text text-white">
            <p>
              <strong>
                PT Foremost Mebel Indonesia adalah produsen furniture dan OEM
                yang berbasis di Indonesia, dan resmi didirikan pada tahun 2021.
              </strong>{" "}
              Selain dikenal sebagai mitra OEM terpercaya untuk klien global,
              kami juga dengan bangga mengembangkan, memproduksi, dan memasarkan
              merek kami sendiri, yang mencakup kasur, bantal, dan produk
              furniture kenyamanan lainnya.
            </p>
            <p>
              Keahlian kami mencakup berbagai produk furniture dan komponen
              custom, termasuk kasur, bantal, produk berbasis busa, serta
              berbagai item lain yang disesuaikan dengan spesifikasi pelanggan —
              baik dari segi desain, material, maupun fungsi. Kami menyediakan
              layanan OEM secara menyeluruh, mulai dari pengembangan produk dan
              pembuatan prototipe, hingga pengadaan material, produksi massal,
              dan pengendalian kualitas yang ketat — untuk mendukung bisnis
              dalam membangun koleksi produk bermerek mereka sendiri.
            </p>
            <p>
              Dengan fokus pada konsistensi, fleksibilitas, dan ketepatan waktu,
              kami membantu pertumbuhan merek klien maupun merek kami sendiri
              melalui solusi furniture siap produksi yang dirancang secara
              cermat agar sesuai dengan kebutuhan pasar masing-masing.
            </p>
          </div>
        </div>
      </section>

      {/* Section 3: Vision & Mission */}
      <section className="vision-mission-section" data-aos="fade-right">
        <div className="row g-4">
          {/* Vision */}
          <div className="col-md-6">
            <div className="card-box hover-card">
              <div className="face face1">
                <div className="content">
                  <h3>VISI KAMI</h3>
                  <ul>
                    <li>
                      Menjadi pemimpin terpercaya dalam industri manufaktur
                      furnitur Indonesia, yang dikenal karena memberikan solusi
                      OEM berkualitas tinggi dan kustomisasi yang memperkuat
                      merek klien kami — baik di pasar lokal maupun, di masa
                      depan, secara global.
                    </li>
                    <li>
                      Mendorong praktik manufaktur yang bertanggung jawab dengan
                      mengintegrasikan keberlanjutan dan inovasi ke dalam proses
                      produksi kami.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="face face2">
                <h2>Visi</h2>
              </div>
            </div>
          </div>

          {/* Mission */}
          <div className="col-md-6">
            <div className="card-box hover-card">
              <div className="face face1">
                <div className="content">
                  <h3>MISI KAMI</h3>
                  <ul>
                    <li>
                      Menyediakan solusi furnitur yang andal, terjangkau, dan
                      disesuaikan yang mencerminkan desain serta tujuan merek
                      klien kami.
                    </li>
                    <li>
                      Menjaga keunggulan di seluruh siklus manufaktur — dari
                      pengembangan produk dan prototipe hingga pengadaan,
                      produksi, dan pengendalian mutu.
                    </li>
                    <li>
                      Membangun kemitraan yang berkelanjutan melalui
                      transparansi, konsistensi, dan kepuasan pelanggan.
                    </li>
                    <li>
                      Berkontribusi pada pertumbuhan berkelanjutan industri
                      furnitur Indonesia melalui praktik ramah lingkungan dan
                      kesiapan ekspor di masa depan.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="face face2">
                <h2>Misi</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Goal Section */}
      <section className="goals-section" data-aos="fade-in">
        <h3 className="section-title">TUJUAN KAMI</h3>
        <div className="goals-container">
          <div className="goal-card">
            <FaCheckCircle className="goal-icon" />
            <h5>Meningkatkan Kualitas dan Konsistensi Produk</h5>
            <p>
              Terus menyempurnakan standar manufaktur untuk menghasilkan
              furnitur yang tahan lama, fungsional, dan memiliki estetika yang
              menarik sesuai dengan harapan klien.
            </p>
          </div>

          <div className="goal-card">
            <MdPeopleAlt className="goal-icon" />
            <h5>Memperkuat Solusi yang Berfokus pada Klien</h5>
            <p>
              Mengembangkan layanan OEM yang fleksibel dan dapat disesuaikan
              dengan desain, branding, dan kebutuhan pasar masing-masing klien.
            </p>
          </div>

          <div className="goal-card">
            <RiMapPin2Fill className="goal-icon" />
            <h5>Memperluas Kehadiran di Pasar Domestik</h5>
            <p>
              Memperkuat jejak kami di berbagai wilayah strategis di Indonesia
              melalui kemitraan dengan pengecer lokal, kontraktor proyek, dan
              klien dari sektor perhotelan.
            </p>
          </div>
        </div>
      </section>

      {/* Section 5: Extended Goals with Diamond Images */}
      <section className="extended-goals-section py-5" data-aos="fade-down">
        
        <div className="container">
          <div className="row g-4">
            {/* Card 1 */}
            <div className="col-12 col-md-6">
              <div className="goal-card h-100">
                <div className="goal-icon-box">
                  <FontAwesomeIcon icon={faLeaf} className="goal-icon" />
                </div>
                <div className="goal-text">
                  <h5>Mendorong Praktik Manufaktur Berkelanjutan</h5>
                  <p>
                    Mengintegrasikan bahan ramah lingkungan dan metode
                    produksi yang efisien untuk meminimalkan dampak
                    terhadap lingkungan serta mendukung inisiatif hijau.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-12 col-md-6">
              <div className="goal-card h-100">
                <div className="goal-icon-box">
                  <FontAwesomeIcon
                    icon={faMicrochip}
                    className="goal-icon"
                  />
                </div>
                <div className="goal-text">
                  <h5>Berinvestasi dalam Inovasi dan Teknologi</h5>
                  <p>
                    Mengadopsi alat manufaktur modern, perangkat lunak
                    desain, dan otomatisasi proses untuk meningkatkan
                    produktivitas serta kemampuan kustomisasi.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-12 col-md-6">
              <div className="goal-card h-100">
                <div className="goal-icon-box">
                  <FontAwesomeIcon icon={faUsers} className="goal-icon" />
                </div>
                <div className="goal-text">
                  <h5>
                    Mengembangkan Tenaga Kerja yang Terampil dan
                    Termotivasi
                  </h5>
                  <p>
                    Menyediakan pelatihan berkelanjutan dan peluang
                    pengembangan karier untuk memastikan lingkungan kerja
                    yang aman, produktif, dan penuh semangat.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 4 */}
            <div className="col-12 col-md-6">
              <div className="goal-card h-100">
                <div className="goal-icon-box">
                  <FontAwesomeIcon
                    icon={faGlobeAsia}
                    className="goal-icon"
                  />
                </div>
                <div className="goal-text">
                  <h5>
                    Membangun Fondasi untuk Pertumbuhan Internasional di
                    Masa Depan
                  </h5>
                  <p>
                    Menyelaraskan standar produk dengan ekspektasi pasar
                    global serta membangun kesiapan ekspor yang strategis.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>

      {/* Section 6 */}
      <section
        className="about-hero d-flex flex-column justify-content-center align-items-center text-white text-center"
        data-aos="zoom-out"
      >
        <h1>Produsen Asli. Mitra OEM Terpercaya.</h1>
        <p>
          Dengan MOQ yang fleksibel, waktu produksi yang cepat, dan komitmen
          terhadap kualitas,
          <br />
          kami membantu Anda mewujudkan ide secara efisien dan andal.
        </p>
      </section>

      {/* FOOTER SECTION */}
      <div
        className="footer-section text-white section-fade"
        style={{ backgroundColor: "#754c24" }}
        data-aos="fade-up"
      >
        <div className="container-fluid px-0">
          <div className="row g-0">
            <div
              className="col-md-3 d-flex align-items-center justify-content-center"
              style={{ backgroundColor: "#5c3e1c", position: "relative" }}
            >
              <img
                src="/images/dotwall.jpg"
                alt="FORMEB Logo"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  zIndex: 0,
                }}
              />
              <div
                className="text-center py-4 px-3"
                style={{ zIndex: 1, position: "relative" }}
              >
                <img
                  src="/images/logo.png"
                  alt="FORMEB Logo"
                  style={{ maxWidth: "350px" }}
                />
                <p className="footer-tagline mt-2 fst-italic text-white">
                  Foremost Living Style
                </p>
              </div>
            </div>

            <div className="col-md-9 px-4 py-5">
              <div className="row text-start">
                <div className="col-md-4 mb-4 mb-md-0 border-end border-light px-4">
                  <h5 className="footer-title text-white">PRODUK</h5>
                  <ul className="list-unstyled footer-links">
                    <li>Kasur</li>
                    <li>Bantal</li>
                    <li>Busa</li>
                  </ul>
                </div>
                <div className="col-md-4 mb-4 mb-md-0 border-end border-light px-4">
                  <h5 className="footer-title text-white">TENTANG KAMI</h5>
                  <ul className="list-unstyled footer-links">
                    <li>
                      <Link
                        to="/about-id#company-profile"
                        className="text-white text-decoration-none"
                      >
                        Profil Perusahaan
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        Servis
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        Proyek Kami
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        Karir
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4 ps-4">
                  <h5 className="footer-title text-white">KONTAK</h5>
                  <ul className="list-unstyled footer-links">
                    <li>
                      <Link
                        to="/contact-id"
                        className="text-white text-decoration-none"
                      >
                        Kontak Kami
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/contact-id"
                        className="text-white text-decoration-none"
                      >
                        Lokasi Kami
                      </Link>
                    </li>
                    <li className="mt-2">
                      <a
                        href="mailto:xxxxxx@gmail.com"
                        className="text-white me-3"
                      >
                        <i className="bi bi-envelope"></i>
                      </a>
                      <a
                        href="https://www.linkedin.com/company/pt-foremost-mebel-indonesia/posts/?feedView=all"
                        className="text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="bi bi-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <hr className="text-light my-4" />
              <div className="row">
                <div className="col-md-6">
                  <p className="footer-email fw-bold text-white">
                    contact@formeb.id
                  </p>
                  <address className="footer-address text-white mt-2">
                    PT. FOREMOST MEBEL INDONESIA
                    <br />
                    Jl. Gemilang, RT.002/RW.003, Tlajung Udik,
                    <br />
                    Kec. Gn. Putri, Kabupaten Bogor, Jawa Barat 16963
                  </address>
                </div>
              </div>
              <div className="d-flex justify-content-end mt-4 small text-light">
                ©2025 Foremost Mebel Indonesia. All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
